/* eslint-disable arrow-parens */
import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import tag from 'clean-tag';
import { withRouter } from 'react-router';

import { Box } from '../Layout';
import Container from '../Layout/Container';
import NavItems from './NavItems';
import menuIconUrl from '../images/menu.svg';

const Wrapper = styled(Box)`
  height: ${themeGet('space.8')};
  position: sticky;
  top: 0;
  z-index: 9999;
  height: 60px;
  display: flex;
  align-items: center;
  display: block;

  @media (max-width: ${themeGet('breakpoints.0')}) {
    display: none;
  }
`;

const BurgerDrawer = styled(Box)`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background: ${themeGet('colors.brand.primary')};
  opacity: ${(props) => (props.isOpen ? '1' : '0')};
  transform: translateX(${(props) => (props.isOpen ? '0' : '-100%')});
  will-change: transform;
  z-index: ${(props) => (props.isOpen ? '8' : '-1')};
  display: none;
  @media (max-width: ${themeGet('breakpoints.0')}) {
    display: block;
  } ;
`;

const Burger = styled(Box)`
  position: absolute;
  top: 18px;
  right: 18px;
  display: none;
  z-index: 9;
  padding: 4px;
  line-height: 0;
  &:hover {
    background: ${themeGet('colors.brand.primary')};
  }
  @media (max-width: ${themeGet('breakpoints.0')}) {
    display: block;
  } ;
`;

const BurgerIcon = styled(tag.img)`
  height: 40px;
  width: 40px;
`;

class MainNav extends Component {
  state = {
    isOpen: false,
  };

  componentDidUpdate(prevProps) {
    // debugger;
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.closeDrawer();
    }
  }

  toggleDrawer = () => {
    const isOpen = !this.state.isOpen;
    // eslint-disable-next-line object-curly-newline
    this.setState({ isOpen });
  };

  closeDrawer = () => {
    // eslint-disable-next-line object-curly-newline
    this.setState({ isOpen: false });
  };

  render() {
    return (
      <Fragment>
        <Wrapper bg="white">
          <Container>
            <NavItems />
          </Container>
        </Wrapper>
        <Burger onClick={this.toggleDrawer} isOpen={this.state.isOpen}>
          <BurgerIcon src={menuIconUrl} />
        </Burger>
        <BurgerDrawer isOpen={this.state.isOpen} p={8}>
          <NavItems />
        </BurgerDrawer>
      </Fragment>
    );
  }
}

export default withRouter(MainNav);



// WEBPACK FOOTER //
// ./src/MainNav/MainNav.js